export default "__VITE_PUBLIC_ASSET__9fda4d3f__"